import { render, staticRenderFns } from "./ProductizeTransformedAttributesCreate.vue?vue&type=template&id=5bc48780&scoped=true"
import script from "./ProductizeTransformedAttributesCreate.vue?vue&type=script&lang=js"
export * from "./ProductizeTransformedAttributesCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductizeTransformedAttributesCreate.vue?vue&type=style&index=0&id=5bc48780&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc48780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc48780')) {
      api.createRecord('5bc48780', component.options)
    } else {
      api.reload('5bc48780', component.options)
    }
    module.hot.accept("./ProductizeTransformedAttributesCreate.vue?vue&type=template&id=5bc48780&scoped=true", function () {
      api.rerender('5bc48780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/ProductizeTransformedAttributesCreate.vue"
export default component.exports